var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73047 10.833L10.2305 7.70801H7.23047V5.52051C7.23047 4.64551 7.54297 3.95801 8.91797 3.95801H10.3555V1.08301C9.54297 0.958008 8.66797 0.833008 7.85547 0.833008C5.29297 0.833008 3.48047 2.39551 3.48047 5.20801V7.70801H0.667969V10.833H3.48047V18.958C4.73047 18.958 5.98047 18.958 7.23047 18.958V10.833H9.73047Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.29ccf4df.svg";
export { ForwardRef as ReactComponent };